import ReactRailsUJS from 'react_ujs';
import "core-js/stable";
import "regenerator-runtime/runtime";
import '@brandfolder/react/lib/esm/index.css';
import { dynamicActivate } from '@helpers/lingui';
import { initializeAmplitude } from '@helpers/amplitude-init';

ReactRailsUJS.useContext(require.context('components', true));
window.dynamicActivate = dynamicActivate;
window.bfTranslate = (str) => str; // placeholder to ensure bfTranslate defined for embed.html.slim layout

// Initialize Amplitude when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  console.log("DOMContentLoaded");
  initializeAmplitude();
});
